
<!-- On enleve le d-flex pour permettre le masquage (d-none) au niveau des row -->
<!-- Des tests unitaires de non régression ont été effectués sur les pages du Formulaire -->
<div
  :id="content.idHTML"
  class="flex-column"
  :class="[jel_getClassObject(content), { 'h-100': prendrePleineHauteur }]"
>
  <EditableArea
    v-if="content.formatAffichage.field != 'carrousel'"
    class="row h-100"
    :class="content.gutters ? 'gutters-' + content.gutters : 'no-gutters'"
    :content="content.row"
    :parentTemplateId="metadata['mgnl:template']"
  >
  </EditableArea>
  <component
    :is="'carrousel'"
    v-if="content.formatAffichage.field == 'carrousel'"
    :key="content['@id']"
    :content="content"
    :metadata="metadata"
  >
  </component>
</div>
